var ControlGroup      = require("app/ui/ControlGroup"),
    HyperLinkSupport  = require("enyo-ui/HyperLinkSupport"),
    IconButton        = require("app/ui/IconButton"),
    Input             = require("app/ui/Input"),
    InputWrapper      = require("app/ui/InputWrapper"),
    Layout            = require("./SharePopupLayout"),
    LinkCopiedMessage = require("./LinkCopiedMessage"),
    ScrollerPopup     = require("app/ui/ScrollerPopup"),
    buttons           = require("app/theme/buttons"),
    frameThrottle     = require("enyo-perf/utils").frameThrottle,
    get               = require("object-path").get,
    icons             = require("app/theme/icons"),
    kind              = require("enyo/kind"),
    onHyperlinkTap    = require("app/utils/onHyperlinkTap"),
    themeVars         = require("app/theme/variables.js");

require("./SharePopup.less");
require("app/theme/ControlGroup--default.less");
require("app/theme/Input--default.less");
require("app/theme/styles/popups/ScrollerPopup--borderless.less");
require("app/ui/ControlGroup.less");

module.exports = kind(/** @lends  app.Sharing.SharePopup.prototype */ {

    /**
     * @private
     */
    name: "app.Sharing.SharePopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:       "fullLayout",
        expand:          false,
        overlapSafeArea: false,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx();
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-sharing-share-popup",

    /**
     * @private
     */
    theme: "borderless",

    /**
     * @private
     */
    showCloseButton: false,

    /**
     * @private
     */
    floating: true,

    /**
     * @private
     */
    useScrim: true,

    /**
     * @private
     */
    shareData: null,

    /**
     * @private
     */
    components: [{
        name:       "content",
        classes:    "app-sharing-share-popup__content",
        components: [{
            classes:    "app-sharing-share-popup__header",
            components: [{
                name:    "title",
                classes: "app-sharing-share-popup__title",
                tag:     "h4"
            }, {
                name:    "inContentCloseButton",
                kind:    IconButton,
                classes: "app-sharing-share-popup__close-button",
                icon:    icons["app.Sharing.SharePopup.closeButton"],
                theme:   buttons["app.Sharing.SharePopup.inContentCloseButton"],
                ontap:   "close"
            }]
        }, {
            name:       "buttonBar",
            classes:    "app-sharing-share-popup__button-bar",
            components: [{
                name:    "facebookButton",
                kind:    IconButton,
                mixins:  [HyperLinkSupport],
                classes: "app-sharing-share-popup__facebook-button",
                icon:    icons["app.Sharing.SharePopup.facebook"],
                theme:   buttons["app.Sharing.SharePopup.shareButton"],
                ontap:   "onHyperlinkTap"
            }, {
                name:    "whatsappButton",
                kind:    IconButton,
                mixins:  [HyperLinkSupport],
                classes: "app-sharing-share-popup__whatsapp-button",
                icon:    icons["app.Sharing.SharePopup.whatsapp"],
                theme:   buttons["app.Sharing.SharePopup.shareButton"],
                ontap:   "onHyperlinkTap"
            }, {
                name:    "xButton",
                kind:    IconButton,
                mixins:  [HyperLinkSupport],
                classes: "app-sharing-share-popup__x-button",
                icon:    icons["app.Sharing.SharePopup.x"],
                theme:   buttons["app.Sharing.SharePopup.shareButton"],
                ontap:   "onHyperlinkTap"
            }, {
                name:    "emailButton",
                kind:    IconButton,
                tag:     "a",
                classes: "app-sharing-share-popup__email-button",
                icon:    icons["app.Sharing.SharePopup.email"],
                theme:   buttons["app.Sharing.SharePopup.shareButton"]
            }]
        }, {
            name:       "copyLink",
            kind:       ControlGroup,
            classes:    "app-sharing-share-popup__copy-link",
            components: [{
                kind:       InputWrapper,
                components: [{
                    name:       "linkInput",
                    kind:       Input,
                    classes:    "icon-right",
                    type:       "text",
                    attributes: {
                        readonly: "readonly"
                    },
                    theme: "default"
                }, {
                    name:       "copyButton",
                    kind:       IconButton,
                    classes:    "right-of-input",
                    tag:        "button",
                    attributes: {
                        type: "button"
                    },
                    ondown: "onCopyButtonDown",
                    ontap:  "onCopyButtonTap",
                    theme:  buttons["app.Sharing.SharePopup.copyButton"],
                    icon:   icons["app.Sharing.SharePopup.copyButton"]
                }]
            }]
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["shareData"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var $i18nService    = this.app.$.i18nService,
            $facebookButton = this.$.facebookButton,
            $xButton        = this.$.xButton,
            $whatsappButton = this.$.whatsappButton,
            $emailButton    = this.$.emailButton,
            shareData       = this.shareData,
            shareUrl        = get(shareData, "url", null);

        this.$.title.set("content", $i18nService.getString("app.Sharing.SharePopup.title"));

        this.$.closeButton.set("tooltip", $i18nService.getString("app.Sharing.SharePopup.CloseButton.tooltip"));

        $facebookButton.set("caption", $i18nService.getString("app.Sharing.SharePopup.facebookButton.caption"));
        $xButton.set("caption", $i18nService.getString("app.Sharing.SharePopup.xButton.caption"));
        $whatsappButton.set("caption", $i18nService.getString("app.Sharing.SharePopup.whatsappButton.caption"));
        $emailButton.set("caption", $i18nService.getString("app.Sharing.SharePopup.emailButton.caption"));

        if (shareUrl) {
            $facebookButton.set("href", "https://www.facebook.com/sharer/sharer.php?u={url}".replace("{url}", shareUrl));
            $xButton.set("href", "https://twitter.com/intent/tweet?url={url}".replace("{url}", shareUrl));
            $whatsappButton.set("href", "https://api.whatsapp.com/send?text={url}".replace("{url}", shareUrl));
            $emailButton.setAttribute("href", "mailto:?body={url}".replace("{url}", shareUrl));
        }
        else {
            $facebookButton.set("href", null);
            $xButton.set("href", null);
            $whatsappButton.set("href", null);
            $emailButton.setAttribute("href", null);
        }

        this.$.linkInput.setAttribute("value", get(shareData, "url", null));

        this.$.copyButton.set("tooltip", $i18nService.getString("app.Sharing.SharePopup.CopyButton.tooltip"));
    },

    /**
     * Should prevent blurring the input.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    onCopyButtonDown: function(sender, event) {
        event.preventDefault();
    },

    /**
     * Toggles the visibility of the password.
     *
     * @private
     */
    onCopyButtonTap: function() {
        var $linkInput = this.$.linkInput,
            linkInput  = $linkInput.hasNode(),
            link       = linkInput.value;

        if ("clipboard" in navigator) {
            navigator.clipboard.writeText(link).then(this.bindSafely(function() {
                this.showLinkCopiedMessage();
            }));
        }
        else {
            if (document.execCommand("copy", true, link)) {
                this.showLinkCopiedMessage();
            }
        }
    },

    /**
     * @private
     */
    showLinkCopiedMessage: function() {
        var toast;

        toast = this.$.copyLink.createComponent({
            kind: LinkCopiedMessage
        });

        this.hasNode() && toast.render();
    },

    /**
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
